import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import MainScreen from './components/MainScreen';
import Login from './components/Login';
import Secure from './components/Secure';
import Pensions from './components/Pensions';
import Expenses from './components/Expenses';
import Billing from './components/Billing';
import { getAccessToken } from './utils';

function ProtectedRoute({ children }) {
  const token = getAccessToken();
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function AppLayout({ children }) {
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar />
        <main className="flex-1 overflow-y-auto bg-slate-50 p-6">
          {children}
        </main>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/secure" element={<Secure />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AppLayout><MainScreen /></AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/pensions"
          element={
            <ProtectedRoute>
              <AppLayout><Pensions /></AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/expenses"
          element={
            <ProtectedRoute>
              <AppLayout><Expenses /></AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/billing"
          element={
            <ProtectedRoute>
              <AppLayout><Billing /></AppLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}
